import Cookies from "js-cookie";
import EnvironmentService from "./environmentService";

export default class ProjectService {

    constructor() {
        this.environmentService = new EnvironmentService();
    }

    async retrieveProjects() {
        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Project",
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token")
                }
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }

    }
    async createNewProject(projectNameString) {
        const queryString = "?projectName=" + encodeURIComponent(projectNameString);

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Project" + queryString,
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token")
                },
                method: "POST"
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }

    async getProjectInDetail(projectUUID) {
        const queryString = "?projectUUID=" + encodeURIComponent(projectUUID);

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/Project/Detail" + queryString,
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token")
                }
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }
}


// WEBPACK FOOTER //
// ./src/service/projectService.js